import linkedinLogo from '../assets/images/auth/linkedin-logo.svg';
import facebookLogo from '../assets/images/auth/facebook-logo.svg';
import googleLogo from '../assets/images/auth/google-logo.svg';

export const logos = {
    LinkedIn: linkedinLogo,
    Facebook: facebookLogo,
    Google: googleLogo,
};